import { ScoreHistory, ScoreHistoryEntry } from "@/models/gameState";
import { Score } from "@/models/pdfData";

export const getScoreFromHistory = (
  scoreHistory: ScoreHistory,
  scoreIndex: number,
): ScoreHistoryEntry => {
  const allScores = Object.entries(scoreHistory).flatMap(
    ([setNumber, setScores]) =>
      setScores.map(
        (scoreHistoryEntry) =>
          ({
            setNumber: parseInt(setNumber),
            score: {
              team1: scoreHistoryEntry[1],
              team2: scoreHistoryEntry[2],
            } as Score,
          }) as ScoreHistoryEntry,
      ),
  );

  if (scoreIndex >= 0) {
    return allScores[scoreIndex];
  } else {
    return allScores[allScores.length + scoreIndex];
  }
};
